import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { logout } from '../Redux/Actions/AuthActions';
import logo from "../image/bookly_logo.png";
import './NavAuth.css';

const NavAuth = () => {
  const dispatch = useDispatch();
  const token = localStorage.getItem('token');
  const user = useSelector(state => state.AuthReducer.user);
  const navigate = useNavigate();
  const location = useLocation();

  const currentPath = location.pathname;

  const isActive = (path) => currentPath === path ? 'active' : '';

  return (
    <>
      {/* Top Navbar (Default on desktop, logo header on mobile) */}
      <nav className="bookly-navbar">
        <div className="bookly-container">
          <Link to="/" className="bookly-logo-link">
            <img src={logo} alt="Bookly Logo" className="bookly-logo-img" />
            <span className="bookly-brand">Bookly</span>
          </Link>

          {/* Desktop Menu links (hidden on mobile) */}
          <div className="bookly-menu">
            <ul className="bookly-nav-list">
              <li><Link to="/" className={`bookly-nav-link ${isActive('/')}`}>Accueil</Link></li>
              {token && user ? (
                <>
                  {user.role === 'provider' ? (
                    <>
                      <li><Link to="/ProviderDashboard" className={`bookly-nav-link ${isActive('/ProviderDashboard')}`}>Dashboard</Link></li>
                      <li><Link to="/Profil" className={`bookly-nav-link ${isActive('/Profil')}`}>Profil</Link></li>
                    </>
                  ) : (
                    <>
                      <li><Link to="/SalonBookingModule" className={`bookly-nav-link ${isActive('/SalonBookingModule')}`}>Rendez-vous</Link></li>
                      <li><Link to="/Profil" className={`bookly-nav-link ${isActive('/Profil')}`}>Profil</Link></li>
                      {(user.role === 'admin' || user.role === 'useradmin') && (
                        <>
                          <li><Link to="/AdminApprovals" className={`bookly-nav-link ${isActive('/AdminApprovals')}`}>Approbations</Link></li>
                          <li><Link to="/ActivityManagement" className={`bookly-nav-link ${isActive('/ActivityManagement')}`}>Activités</Link></li>
                          <li><Link to="/ServiceManagement" className={`bookly-nav-link ${isActive('/ServiceManagement')}`}>Services</Link></li>
                          <li><Link to="/PackManagement" className={`bookly-nav-link ${isActive('/PackManagement')}`}>Packs</Link></li>
                          <li><Link to="/AllUser" className={`bookly-nav-link ${isActive('/AllUser')}`}>Utilisateurs</Link></li>
                        </>
                      )}
                    </>
                  )}
                </>
              ) : (
                <>
                  <li><Link to="/Login" className={`bookly-nav-link ${isActive('/Login')}`}>Connexion</Link></li>
                  <li><Link to="/Register" className={`bookly-nav-link ${isActive('/Register')}`}>Inscription</Link></li>
                </>
              )}
            </ul>
          </div>

          {/* Desktop User Section */}
          {token && user && (
            <div className="bookly-profile-section">
              <span className="bookly-username d-none d-md-inline">
                {user.businessName || user.name}
              </span>
              <Link to="/Profil" className="bookly-profile-badge">
                {(user.businessName || user.name)?.charAt(0).toUpperCase()}
              </Link>
              <button
                className="bookly-logout-btn d-none d-md-inline-block"
                onClick={() => {
                  navigate('/');
                  dispatch(logout());
                }}
              >
                Déconnexion
              </button>
            </div>
          )}
        </div>
      </nav>

      {/* Fixed Bottom Navigation Bar (Visible only on mobile) */}
      <div className="bookly-bottom-nav">
        <Link to="/" className={`bookly-bottom-tab ${isActive('/')}`}>
          <span className="bookly-bottom-tab-icon">🏠</span>
          <span>Accueil</span>
        </Link>

        {token && user ? (
          <>
            {user.role === 'provider' ? (
              <Link to="/ProviderDashboard" className={`bookly-bottom-tab ${isActive('/ProviderDashboard')}`}>
                <span className="bookly-bottom-tab-icon">📊</span>
                <span>Dashboard</span>
              </Link>
            ) : user.role === 'admin' || user.role === 'useradmin' ? (
              <Link to="/AdminApprovals" className={`bookly-bottom-tab ${isActive('/AdminApprovals')}`}>
                <span className="bookly-bottom-tab-icon">🛡️</span>
                <span>Approbations</span>
              </Link>
            ) : (
              <Link to="/SalonBookingModule" className={`bookly-bottom-tab ${isActive('/SalonBookingModule')}`}>
                <span className="bookly-bottom-tab-icon">📅</span>
                <span>Mes RDV</span>
              </Link>
            )}

            <Link to="/Profil" className={`bookly-bottom-tab ${isActive('/Profil')}`}>
              <span className="bookly-bottom-tab-icon">👤</span>
              <span>Profil</span>
            </Link>
          </>
        ) : (
          <>
            <Link to="/Login" className={`bookly-bottom-tab ${isActive('/Login')}`}>
              <span className="bookly-bottom-tab-icon">🔑</span>
              <span>Connexion</span>
            </Link>
            <Link to="/Register" className={`bookly-bottom-tab ${isActive('/Register')}`}>
              <span className="bookly-bottom-tab-icon">📝</span>
              <span>Inscription</span>
            </Link>
          </>
        )}
      </div>
    </>
  );
};

export default NavAuth;
